import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "frontend-components/lib/utils";

const alertVariants = cva(
    "group/alert border-border-default relative flex w-full items-start gap-3.5 rounded-none border border-l-[3px] bg-white px-[18px] py-4 text-left text-sm has-data-[slot=alert-action]:pr-18 *:[svg]:mt-0.5 *:[svg]:shrink-0 *:[svg:not([class*='size-'])]:size-4",
    {
        variants: {
            variant: {
                success: "border-l-chameleon-green",
                info: "border-l-alert-info",
                warning: "border-l-chameleon-yellow",
                error: "border-l-chameleon-pink",
            },
        },
        defaultVariants: {
            variant: "info",
        },
    },
);

function Alert({
    className,
    variant,
    ...props
}: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
    return (
        <div
            data-slot="alert"
            role="alert"
            className={cn(alertVariants({ variant }), className)}
            {...props}
        />
    );
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="alert-title"
            className={cn(
                "text-text-primary mb-0.5 text-base font-medium [&_a]:underline [&_a]:underline-offset-3",
                className,
            )}
            {...props}
        />
    );
}

function AlertDescription({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="alert-description"
            className={cn(
                "text-text-secondary text-sm leading-relaxed text-balance [&_a]:underline [&_a]:underline-offset-3 [&_p:not(:last-child)]:mb-4",
                className,
            )}
            {...props}
        />
    );
}

function AlertAction({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="alert-action"
            className={cn("absolute top-3 right-3", className)}
            {...props}
        />
    );
}

export { Alert, AlertTitle, AlertDescription, AlertAction, alertVariants };
